import React from 'react'
import PropTypes from 'prop-types'
import { useDrag } from 'react-dnd'
import { Grid } from '@mui/material'

const Draggable = ({ id, children, onlyDragByAnchor, ...restProps }) => {
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: 'card',
    item: {
      id,
    },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }))

  return (
    <Grid
      ref={onlyDragByAnchor ? preview : drag}
      style={{
        opacity: isDragging ? 0 : 1,
      }}
      {...restProps}
    >
      {React.cloneElement(children, { dragAnchorRef: drag })}
    </Grid>
  )
}

Draggable.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onlyDragByAnchor: PropTypes.bool,
}

Draggable.defaultProps = {
  onlyDragByAnchor: false,
}

export default Draggable
